import { Controller } from "@hotwired/stimulus";
import mapbox from 'mapbox-gl';

mapbox.accessToken = document.querySelector('meta[name="mapbox_access_token"]').getAttribute("content")

export default class extends Controller {
  static targets = ['wrapper'];

  connect() {
    // Don't even bother if we're dealing with IE
    if (window.document.documentMode) return;

    const latitude = this.data.get('latitude');
    const longitude = this.data.get('longitude');

    const map = new mapbox.Map({
      container: this.wrapperTarget,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [longitude, latitude],
      zoom: 12
    });

    map.addControl(new mapbox.NavigationControl(), 'top-right');

    new mapbox.Marker({
      color: '#e53e3e'
    })
      .setLngLat([longitude, latitude])
      .addTo(map);
  }
}
